<template>
  <div>
    <v-btn class="btn-add-category" :aria-label="$t('Добавить файл')" @click.native.stop="resetFile( true)">
      <span class="pro-icon-add" aria-hidden="true"></span>
    </v-btn>
    <v-dialog v-model="fileDialog" max-width="600">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t("Сопроводительные документы") }}
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="resetFile(false)">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <div class="files">
            <div class="file-item">
              <v-row>
                <v-col cols="12" sm="12" class="col-file-input">
                  <div class="file-item">
                    <i
                      role="button"
                      tabindex="0"
                      :aria-label="$t('Выберите файлы')"
                      class="v-icon notranslate v-icon--link mdi mdi-paperclip theme--light"
                    ></i>
                    <v-file-input
                      :label="$t('Выберите файлы')"
                      v-model="uploadedFiles"
                      class="v-input__control"
                      multiple
                    >
                    </v-file-input>
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-btn color="primary" dark @click="addFile">
                    {{ $t('Добавить') }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <ol class="selectTypeList">
      <li v-for="item in files" :key="item.id">
        {{ item.name }}
        <span
          class="pro-icon-close"
          role="button"
          tabindex="0"
          :aria-label="$t('Удалить файл') + ': ' + item.name"
          @click="deleteFile(item.lastModified)"
          @keydown.enter.prevent="deleteFile(item.lastModified)"
          @keydown.space.prevent="deleteFile(item.lastModified)"
        ></span>
      </li>
    </ol>

  </div>
</template>

<script>
  export default {
    props: {
      files: Array
    },
    computed: {
      listLocal: {
        get() {
          return this.files
        },
        set(newList) {
          this.$emit('update:files', newList)
        }
      }
    },
    data: () => ({
      fileDialog: false,
      uploadedFiles: []
    }),
    methods: {
      // Обновление формы для добавления
      resetFile (flag) {
        this.fileDialog = flag
        this.uploadedFiles = []
      },
      // Добавление файлов
      addFile() {
        this.uploadedFiles.forEach(f => this.files.push(f))
        this.resetFile(false)
      },
      // Удаление файла
      deleteFile(id) {
        if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
          this.listLocal = this.listLocal.filter(f => f.lastModified !== id)
        }
      }
    }

  }
</script>

<style lang="scss" scoped>
  .col-sm-2,
  .col-sm-3,
  .col-sm-9,
  .col-sm-10 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .form-files {
    label {
      min-width: auto;
    }
  }

  .files {
    .file-item {
      display: flex;

      i {
        position: relative;
        top: -4px;
      }

      .v-input {
        max-width: 240px;
        margin: 0;
        padding: 0;
        white-space: nowrap;
      }
    }
  }
</style>
